import { render, staticRenderFns } from "./message-group-live-status.vue?vue&type=template&id=267d435e&scoped=true&"
import script from "./message-group-live-status.vue?vue&type=script&lang=js&"
export * from "./message-group-live-status.vue?vue&type=script&lang=js&"
import style0 from "./message-group-live-status.vue?vue&type=style&index=0&id=267d435e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267d435e",
  null
  
)

export default component.exports